import React from "react";

import styles from "../../../../styles/edit-category-product.module.scss";

import { Button } from "../../../components/Button";
import { Drawer } from "../../../components/Drawer";
import { Label } from "../../../components/Label";
import { Icon } from "../../../components/core/Icon";

import { CatalogAPI } from "../../../../providers/CatalogAPI";
import { Availability } from "../../../utils/Availability";
import { OptionStepQuestion } from "./FormSteps/Steps/OptionStepQuestion";
import { ProductAvailabilityStep } from "./FormSteps/Steps/ProductAvailabilityStep";
import { ProductDrinkSizes } from "./FormSteps/Steps/ProductDrinkSizes";
import { ProductNameAndImageStep } from "./FormSteps/Steps/ProductNameAndImageStep";
import { ProductStepQuestion } from "./FormSteps/Steps/ProductStepQuestion";
import { ProductTagsStep } from "./FormSteps/Steps/ProductTagsStep";

const ItemToEdit = {
  settings: "settings",
  sizes: "sizes",
  steps: "steps",
  others: "others",
  tags: "tags",
  remove: "remove",
};

const Selector = ({ product, onClick }) => {
  return (
    <>
      <Label>O que você deseja editar?</Label>
      <div className={styles.editOptions}>
        <div onClick={() => onClick(ItemToEdit.settings)}>
          <p>Configurações básicas</p>
          <Icon name="pen" size="sm" />
        </div>
        <div onClick={() => onClick(ItemToEdit.sizes)}>
          <p>Tamanhos</p>
          <Icon name="pen" size="sm" />
        </div>
        {product?.type == "step" && (
          <div onClick={() => onClick(ItemToEdit.steps)}>
            <p>Etapas</p>
            <Icon name="pen" size="sm" />
          </div>
        )}
        <div onClick={() => onClick(ItemToEdit.tags)}>
          <p>Tags</p>
          <Icon name="pen" size="sm" />
        </div>
        <div onClick={() => onClick(ItemToEdit.others)}>
          <p>Outros</p>
          <Icon name="pen" size="sm" />
        </div>
      </div>

      <div className="d-flex justify-center mt-30">
        <Button design="underline" onClick={() => onClick(ItemToEdit.remove)}>
          Remover este produto
        </Button>
      </div>
    </>
  );
};

class EditProduct extends React.Component {
  state = {
    edit: null,
    catalog: {},
    product: {},
    productCopy: {},
    removeProduct: false,
    saveLoading: false,
    removeLoading: false,
    disabled: true,
    openOptionSteps: false,
    selectedOption: null,
    isValid: true,
  };

  async setStateAsync(data) {
    return await new Promise((resolve) => this.setState(data, resolve));
  }

  componentDidMount() {
    const { catalog, product, open } = this.props;
    this.setState({
      catalog,
      product,
      productCopy: product,
      oldProduct: JSON.parse(JSON.stringify(product)),
    });
  }

  getHeaderTitle() {
    const { category, removeCategory, edit } = this.state;

    if (removeCategory) return `Remover categoria "${category.name}"`;
    if (!edit) return `Editar categoria - ${category.name}`;

    const EditTitles = {
      settings: "Configurações básicas",
      sizes: "Tamanhos",
      doughs: "Massas",
      edges: "Bordas",
      extras: "Extras",
      others: "Outros",
    };

    return EditTitles[edit];
  }

  onChangeProduct(values) {
    const { product } = this.state;

    if (values.sizes) {
      values.sizes.forEach((size) => {
        size.parent = product?.id;
      });
    }

    if (values.items) {
      values.items.forEach((item) => {
        item.parent = product?.id;
      });
    }

    this.setState(
      {
        product: { ...product, ...values },
      },
      this.validateStep.bind(this)
    );
  }

  checkEmptyItems(obj) {
    if ("items" in obj && Array.isArray(obj.items) && obj.items.length > 0) {
      for (const item of obj.items) {
        if (Array.isArray(item.items) && item.items.length === 0) {
          return true;
        }
      }
    }
    return false;
  }

  onChangeOption(values) {
    console.log(values)
    const hasEmptyItems = this.checkEmptyItems(values);
    if (hasEmptyItems) this.setState({ isValid: false });
    else this.setState({ isValid: true });

    if (!values.items) return;

    const { selectedOption, product } = this.state;

    const findAndUpdateItem = (items) => {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        if (item.ref_id === selectedOption.ref_id) {
          const updatedItem = { ...item };

          updatedItem.items = values.items;

          if (values.items) {
            for (const childItem of values.items) {
              childItem.parent = selectedOption.id;
            }
          }

          items[i] = updatedItem;
          return true;
        }

        if (item.items && findAndUpdateItem(item.items)) {
          return true;
        }
      }
      return false;
    };

    findAndUpdateItem(product?.items);

    this.setState({ product }, this.validateStep.bind(this));
  }

  validateStep() {
    const { edit, product } = this.state;
    switch (edit) {
      case ItemToEdit.settings:
        return this.setState({ disabled: !product || !product?.name });
      case ItemToEdit.sizes:
        if (product?.type == "drink") {
          return this.setState({
            disabled: product?.sizes.reduce(
              (f, size) =>
                f ||
                !size.package ||
                !size.unit ||
                !size.amount ||
                size.price === "" ||
                size.price === null,
              false
            ),
          });
        } else if (product?.type == "flavor") {
          return this.setState({
            disabled: product?.sizes.reduce(
              (f, size) =>
                f || !size.price || size.price === "" || size.price === null,
              false
            ),
          });
        } else {
          return this.setState({ disabled: false });
        }

      case ItemToEdit.steps:
        if (product?.items.length == 0) {
          return this.setState({ disabled: false });
        }

        const hasEmptyQuestion = product?.items.findIndex((q) => !q.name) > -1;
        const hasEmptyOption =
          product?.items.findIndex(
            (q) => q.items.length == 0 || q.items.findIndex((o) => !o.name) > -1
          ) > -1;
        return this.setState({ disabled: hasEmptyQuestion || hasEmptyOption });

      case ItemToEdit.extras:
        return this.setState({
          disabled:
            product?.extra_ingredients.length > 0 &&
            !product?.extra_ingredients.reduce((previousExtra, extra) => {
              return (
                previousExtra &&
                !!extra.name &&
                extra.sizes.reduce((previousExtraSize, extraSize) => {
                  return (
                    previousExtraSize &&
                    !!extraSize.name &&
                    !!extraSize.price &&
                    Number(String(extraSize.price)) != NaN
                  );
                }, true)
              );
            }, true),
        });
      case ItemToEdit.others:
        return this.setState({
          disabled: Availability.hasIncompleteAvailability(
            product?.availability
          ),
        });
      case ItemToEdit.tags:
        return this.setState({
          disabled: false,
        });
      default:
        return null;
    }
  }

  executeOnSchema(item, callback) {
    for (let field of [
      "items",
      "extra_ingredients",
      "edges",
      "doughs",
      "sizes",
    ]) {
      if (item[field] && item[field].length > 0) {
        for (let childrenIndex in item[field]) {
          const children = item[field][childrenIndex];
          const result = callback(children, item, field, childrenIndex);
          if (result === false) {
            return;
          }

          this.executeOnSchema(children, callback);
        }
      }
    }
  }

  getHeaderTitle() {
    const { product, removeProduct, edit } = this.state;
    if (removeProduct) return `Remover produto "${product?.name}"`;
    if (!edit) return `Editar produto - ${product?.name}`;

    const EditTitles = {
      settings: "Configurações básicas",
      sizes: "Tamanhos",
      steps: "Etapas",
      tags: "Tags",
      others: "Outros",
    };

    return EditTitles[edit];
  }

  updateOldPrice(newSizes, oldSizes) {
    newSizes = newSizes.map((newSize, index) => {
      // if (newSize.id === oldSizes[index].id && newSize.price !== oldSizes[index].price) {
      //     newSize.old_price = oldSizes[index].price;
      // }
      return newSize;
    });
    return newSizes;
  }

  async onSave() {
    await this.setStateAsync({ saveLoading: true });
    const { onProductUpdated } = this.props;
    const { edit, catalog, product, oldProduct } = this.state;

    this.executeOnSchema(catalog, (item, parent, field, index) => {
      item.position = index;
      if (item.id == product?.id && item.type == product?.type) {
        for (const prop of Object.keys(product)) {
          if (prop === "sizes" && product[prop]?.length > 0) {
            product[prop] = this.updateOldPrice(
              product[prop],
              oldProduct[prop]
            );
          }
          item[prop] = product[prop];
        }
      }

      item.availability = Availability.getValidAvailability(item.availability);
    });

    const response = await CatalogAPI.putCatalog(catalog, this.props.service);
    this.setState({
      edit: null,
      saveLoading: false,
      openOptionSteps: false,
      oldProduct: JSON.parse(JSON.stringify(product)),
    });

    onProductUpdated && onProductUpdated();
  }

  async onRemove() {
    const { onProductUpdated, catalog, category, onClose } = this.props;

    await this.setStateAsync({ removeLoading: true });

    const { product } = this.state;
    this.executeOnSchema(catalog, (item) => {
      if (item.type == "category" && item.id == category.id) {
        item.items = item.items.filter((i) => i.id != product?.id);
        return false;
      }
      return true;
    });

    const response = await CatalogAPI.putCatalog(catalog, this.props.service);
    this.setState({ edit: null, removeLoading: false });

    onProductUpdated && onProductUpdated();
    onClose && onClose();
  }

  setEdit(value) {
    this.setState(
      {
        edit: value,
        productCopy: this.state.product,
      },
      this.validateStep.bind(this)
    );
  }

  renderEditContainer() {
    const { catalog, category } = this.props;
    const { edit, product, removeLoading } = this.state;

    const mountPayload = this.onChangeProduct?.bind(this);

    switch (edit) {
      case ItemToEdit.settings:
        return (
          <ProductNameAndImageStep
            product={product}
            onChange={mountPayload}
            stylesObj={styles}
          />
        );
      case ItemToEdit.sizes:
        return (
          <ProductDrinkSizes
            category={category}
            product={product}
            onChange={mountPayload}
          />
        );
      case ItemToEdit.steps:
        return (
          <ProductStepQuestion
            catalog={catalog}
            product={product}
            onChange={mountPayload}
            edit={edit}
            handleOptionSteps={(option) => {
              this.setState({ openOptionSteps: true, selectedOption: option });
              this.setState(
                {
                  edit: "steps",
                  productCopy: this.state.product,
                },
                this.validateStep.bind(this)
              );
            }}
          />
        );
      case ItemToEdit.others:
        return (
          <ProductAvailabilityStep
            catalog={catalog}
            item={product}
            onChange={mountPayload}
          />
        );
      case ItemToEdit.tags:
        return <ProductTagsStep item={product} onChange={mountPayload} />;
      case ItemToEdit.remove:
        return (
          <div className={styles.removeProduct}>
            <p>
              Ao excluir o produto "<strong>{product?.name}</strong>", você
              perderá todas as configurações. Não sendo possível recuperá-las
              após isso.
            </p>
            <Button
              design="primary"
              onClick={this.onRemove.bind(this)}
              className="w-100"
              disabled={removeLoading}
              loading={removeLoading}
            >
              Remover este produto
            </Button>
            <Button
              design="default-2"
              className="mt-20 w-100"
              disabled={removeLoading}
              onClick={() => this.setState({ edit: null })}
            >
              Cancelar
            </Button>
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { open, onClose } = this.props;
    const {
      edit,
      disabled,
      product,
      productCopy,
      saveLoading,
      catalog,
      openOptionSteps,
      selectedOption,
      isValid,
    } = this.state;
    const getHeaderTitle = this.getHeaderTitle.bind(this);

    const mountPayloadOption = this.onChangeOption.bind(this);

    return (
      <Drawer
        visible={open || saveLoading}
        onClose={(status) => onClose(false)}
        closeInFade={false}
        title={getHeaderTitle()}
        subtitle={!edit ? null : productCopy.name}
        showBackButton={edit}
        backButton={() => this.setState({ edit: null, product: productCopy })}
      >
        <div className={styles.scrollContainer}>
          {!edit && (
            <Selector product={product} onClick={this.setEdit.bind(this)} />
          )}
          {this.renderEditContainer()}
        </div>

        {openOptionSteps && (
          <Drawer
            visible={openOptionSteps}
            onClose={() => this.setState({ openOptionSteps: false })}
            withoutTransition
            closeInFade={false}
            title={getHeaderTitle()}
            showBackButton={edit}
            backButton={() => this.setState({ openOptionSteps: false })}
          >
            <OptionStepQuestion
              catalog={catalog}
              option={selectedOption}
              product={product}
              onChange={mountPayloadOption}
              handleOptionSteps={(option) => {
                this.setState({
                  openOptionSteps: true,
                  selectedOption: option,
                });
                this.setState(
                  {
                    edit: "steps",
                    productCopy: this.state.product,
                  },
                  this.validateStep.bind(this)
                );
              }}
            />

            {edit && edit != ItemToEdit.remove && (
              <div className={styles.footer}>
                <Button
                  design="primary"
                  onClick={this.onSave.bind(this)}
                  disabled={
                    disabled ||
                    saveLoading ||
                    product?.availability?.length === 0 ||
                    !isValid
                  }
                  loading={saveLoading}
                >
                  Salvar etapa
                </Button>
              </div>
            )}
          </Drawer>
        )}

        {edit && edit != ItemToEdit.remove && (
          <div className={styles.footer}>
            <Button
              design="primary"
              onClick={this.onSave.bind(this)}
              disabled={
                disabled || saveLoading || product?.availability?.length === 0
              }
              loading={saveLoading}
            >
              Salvar etapa
            </Button>
          </div>
        )}
      </Drawer>
    );
  }
}

export default EditProduct;
